export interface IUserRank {
	userNum: number;
	nickname: string;
	rank: number;
	mmr: number;
}
